import React from "react";
import { isMsalLogin } from "../utils/authConfig";

const LoginLayout = ({ leftContent, formContent }) => {
  return <div id="login">{isMsalLogin ? leftContent : formContent}</div>;
};

export { LoginLayout };
